import { Card, CardContent } from "@/components/ui/card";
import { Play } from "lucide-react";
import { useState } from "react";

export const VideoSection = () => {
  const [selectedVideo, setSelectedVideo] = useState<string | null>(null);

  const videos = [
    {
      id: "gNrkunHJlWE",
      title: "Test des Disques Diamantés Professionnels",
      thumbnail: "/images/disque_elite_precision_2.jpeg",
      duration: "6:12",
      description: "Comparatif détaillé des performances de coupe"
    },
    {
      id: "lN4CqA3FNeI",
      title: "Quel Disque Diamanté Choisir pour le Carrelage ?",
      thumbnail: "/images/disque_elite_precision_3.jpeg",
      duration: "4:00",
      description: "Guide complet pour faire le bon choix"
    },
    {
      id: "dJJ8kJx2fGs",
      title: "Démonstration Disque Diamanté CSV Superpro",
      thumbnail: "/images/disque_elitepro_2.jpeg",
      duration: "2:32",
      description: "Présentation des caractéristiques techniques"
    }
  ];

  return (
    <section className="py-20 bg-gray-900 text-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4">
            Nos Produits en Action
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Découvrez la performance de nos outils à travers ces démonstrations professionnelles
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {videos.map((video) => (
            <Card key={video.id} className="bg-gray-800 border-gray-700 overflow-hidden hover:transform hover:scale-105 transition-all duration-300">
              <div className="relative">
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  className="w-full h-48 object-cover"
                />
                <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center">
                  <button
                    onClick={() => setSelectedVideo(video.id)}
                    className="bg-orange-500 hover:bg-orange-600 rounded-full p-4 transition-colors"
                  >
                    <Play className="h-8 w-8 text-white ml-1" />
                  </button>
                </div>
                <div className="absolute bottom-2 right-2 bg-black bg-opacity-70 text-white text-xs px-2 py-1 rounded">
                  {video.duration}
                </div>
              </div>
              <CardContent className="p-6">
                <h3 className="text-lg font-bold text-white mb-2">{video.title}</h3>
                <p className="text-gray-300 text-sm">{video.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Modal vidéo */}
        {selectedVideo && (
          <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg overflow-hidden max-w-4xl w-full">
              <div className="flex justify-between items-center p-4 border-b">
                <h3 className="text-lg font-bold text-gray-900">
                  {videos.find(v => v.id === selectedVideo)?.title}
                </h3>
                <button
                  onClick={() => setSelectedVideo(null)}
                  className="text-gray-500 hover:text-gray-700 text-2xl"
                >
                  ×
                </button>
              </div>
              <div className="aspect-video">
                <iframe
                  src={`https://www.youtube.com/embed/${selectedVideo}?autoplay=1`}
                  title="Video player"
                  className="w-full h-full"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};